/**
 * 計上処理
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/sales/requests/billing_processes`

 const sales_billing_process = {
   namespaced: true,
   actions: {
     create ({ commit }, { params }) {
       return new Promise( ( resolve ) => {
         Vue.$http.post(API_PATH, params).then( data => {
           let content = data.content
           commit('snackbar/showInfo', { message: '請求データ作成処理を開始しました。処理完了まで時間がかかる場合があります。\n画面に結果が表示されない場合は、再検索または画面を更新してください。', timeout: 7000 }, { root: true })
           resolve(content)
         } )
       })
     },
   },
 }

 export default sales_billing_process
